import { theme } from 'antd';

const darkTheme = {
  "token": {
    "colorPrimary": "#974e55",
    "colorInfo": "#974e55",
    "colorTextBase": "#efefef",
    "colorWarning": "#efd000",
    "colorSuccess": "#47b410"
  },
  "algorithm": theme.darkAlgorithm
}

export default darkTheme;
